<template lang="html">
  <div>
    <div class="content">
      <h1>Notifikace</h1>
      <v-layout class="layout--controls">
        <v-btn
          color="primary"
          type="submit"
          class="button--top control"
          :to="{ name: 'Notifications-new' }"
          >Vytvořit notifikaci</v-btn
        >
      </v-layout>
      <v-layout class="table-items">
        <v-data-table
          locale="cs"
          :headers="headers"
          :items="items"
          :loading="!loaded"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
          :no-data-text="'Žádná data'"
          :no-results-text="'Nenalezeno'"
          :server-items-length="totalItems"
          :footer-props="{
            'items-per-page-text': 'zobrazit',
            'items-per-page-options': [10, 20, 50, 100, 150],
          }"
          @update:options="footOpts"
        >
          <template v-slot:item.content="{ item }">
            <span v-if="item.content"> </span>
          </template>
          <template v-slot:item.is_planned="{ item }">
            <span v-if="item.is_planned">
              Ano
            </span>
            <span v-else>Ne</span>
          </template>
          <template v-slot:item.remove="{ item }">
            <v-btn color="error" @click="openDeleteNotificationDialog(item)"
              >Smazat</v-btn
            >
          </template>
          <template v-slot:item.detail="{ item }">
            <v-btn
              v-if="item.is_planned"
              color="primary"
              @click="
                $router.push({
                  name: 'NotificationsDetail',
                  params: { id: item.id },
                })
              "
              >Detail</v-btn
            >
          </template>

          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet notifikací na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>

      <v-row justify="center">
        <v-dialog v-model="deleteNotificationDialog" persistent max-width="680">
          <v-card v-if="focusedNotification">
            <v-card-title class="text-h5 mb-8">
              <span style="word-break:break-word;">
                Smazat notifikaci
              </span>
            </v-card-title>
            <v-card-text>
              Opravdu si přejete smazat notifikaci
              <i>{{ focusedNotification.title }} </i>?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="
                  (deleteNotificationDialog = false),
                    (focusedNotification = null)
                "
              >
                zavřít
              </v-btn>
              <v-btn
                color="error"
                text
                :loading="deletingNotification"
                @click="handleDeleteNotification"
              >
                Smazat
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {},

  data() {
    return {
      loaded: false,
      headers: [
        { text: 'ID', value: 'id', align: 'left', sortable: false },
        { text: 'Titulek', value: 'title', align: 'left', sortable: false },
        // { text: "Obsah", value: "content", align: "left", sortable: false },
        {
          text: 'Vytvořeno',
          value: 'created_at',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Plánovaná',
          value: 'is_planned',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Plánovaná na',
          value: 'time',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Počet otevření',
          value: 'opens_count',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Počet odeslání',
          value: 'targets',
          align: 'left',
          sortable: false,
        },
        { text: '', value: 'remove', align: 'right' },
        { text: '', value: 'detail', align: 'right' },
        { text: '', value: 'controls', align: 'right' },
      ],
      items: [],
      totalItems: 0,
      perPage: 10,
      sortBy: 'id',
      sortDesc: true,
      page: 1,
      deleteNotificationDialog: false,
      focusedNotification: null,
      deletingNotification: false,
    };
  },

  created() {},
  computed: {
    ...mapState(['profile']),
  },
  mounted() {},
  methods: {
    async handleDeleteNotification() {
      try {
        if (this.focusedNotification) {
          this.deletingNotification = true;
          await this.$axios.delete(
            `/notifications/admin/${this.focusedNotification.id}`
          );
          await this.index();
          this.deletingNotification = false;
          this.focusedNotification = null;
          this.deleteNotificationDialog = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    openDeleteNotificationDialog(notification) {
      this.focusedNotification = notification;
      this.deleteNotificationDialog = true;
    },
    formatCreatedAt(date) {
      if (date) {
        return moment(date).format('D.M.YYYY - HH:mm');
      } else {
        return null;
      }
    },
    async footOpts(e) {
      this.sortBy = e.sortBy[0] || 'id';
      this.sortDesc = e.sortDesc[0] || false;
      this.page = e.page;
      this.perPage = e.itemsPerPage;
      this.$router
        .replace({
          name: this.$router.name,
          query: {
            page: this.page,
            limit: this.perPage,
          },
        })
        .catch((err) => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes(
              'Avoided redundant navigation to current location'
            )
          ) {
            console.log(err);
          }
        });
      await this.index();
      return;
    },
    async index() {
      try {
        this.loaded = false;
        let url = '/notifications/admin';
        url += `?page=${this.page}&limit=${this.perPage}`;
        const { data } = await this.$axios.get(url);
        console.debug('data', data);
        this.items = data.data;
        this.totalItems = data.count;
        this.loaded = true;
      } catch (error) {
        this.loaded = true;
        console.error(error);
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
